module.exports = __webpack_public_path__ + "img/ufo-beam.5ad119ad.svg";